function getAllGuidesPageLink(): string {
  return `/nos-guides/`;
}

export { getAllGuidesPageLink };
